import { apiCall } from './gqlClient';
const GETMEMBERSHIPS_QUERY = "\n  query getMemberships($groupId: Int) {\n    getMemberships(groupId: $groupId)\n    {\n      id\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\tsessionsCounter\n\t\t\treservationsCounter\n\t\t\tsubscriptionsCounter\n\t\t\talwaysAvailable\n\t\t\tduration\n\t\t\tdurationType\n\t\t\tdurationMonths\n\t\t\tisRecurringPayment\n\t\t\tisPublished\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tmembershipType\n\t\t\tallInclusive\n\t\t\tmembershipTypeIds\n\t\t\tuserHasMembership\n\t\t\torderIndex\n\t\t\twalkinEmail\n\t\t\trules\n      ...fragments\n    }\n  }";
export const getMembershipsApiCall = async function (_ref) {
  let {
    groupId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETMEMBERSHIPS_QUERY,
    variables: {
      groupId
    },
    fragments
  });
};
const GETSINGLEMEMBERSHIPDETAILS_QUERY = "\n  query getSingleMembershipDetails($id: Int!) {\n    getSingleMembershipDetails(id: $id)\n    {\n      id\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\tsessionsCounter\n\t\t\treservationsCounter\n\t\t\tsubscriptionsCounter\n\t\t\talwaysAvailable\n\t\t\tduration\n\t\t\tdurationType\n\t\t\tdurationMonths\n\t\t\tisRecurringPayment\n\t\t\tisPublished\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tmembershipType\n\t\t\tallInclusive\n\t\t\tmembershipTypeIds\n\t\t\tuserHasMembership\n\t\t\torderIndex\n\t\t\twalkinEmail\n\t\t\trules\n      ...fragments\n    }\n  }";
export const getSingleMembershipDetailsApiCall = async function (_ref2) {
  let {
    id
  } = _ref2;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETSINGLEMEMBERSHIPDETAILS_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const GETARCHIVEDMEMBERSHIPS_QUERY = "\n  query getArchivedMemberships {\n    getArchivedMemberships\n    {\n      id\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\tsessionsCounter\n\t\t\treservationsCounter\n\t\t\tsubscriptionsCounter\n\t\t\talwaysAvailable\n\t\t\tduration\n\t\t\tdurationType\n\t\t\tdurationMonths\n\t\t\tisRecurringPayment\n\t\t\tisPublished\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tmembershipType\n\t\t\tallInclusive\n\t\t\tmembershipTypeIds\n\t\t\tuserHasMembership\n\t\t\torderIndex\n\t\t\twalkinEmail\n\t\t\trules\n      ...fragments\n    }\n  }";
export const getArchivedMembershipsApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETARCHIVEDMEMBERSHIPS_QUERY,
    variables: {},
    fragments
  });
};
const GETUSERMEMBERSHIPS_QUERY = "\n  query getUserMemberships($userId: Int, $all: Boolean, $customerId: Int) {\n    getUserMemberships(userId: $userId, all: $all, customerId: $customerId)\n    {\n      id\n\t\t\tuserId\n\t\t\tmembershipId\n\t\t\tsessionsCounter\n\t\t\treservationsCounter\n\t\t\tmembershipType\n\t\t\tmembershipTypeIds\n\t\t\tallInclusive\n\t\t\tisActive\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tdescribedName\n\t\t\tsubscriptionsCounter\n\t\t\tusedSessions\n\t\t\tbookedSessions\n\t\t\tbookedReservations\n\t\t\tusedReservations\n\t\t\ttotalSessionsCounter\n\t\t\ttotalReservationsCounter\n\t\t\tprice\n\t\t\tcustomerId\n\t\t\trules\n\t\t\tisRequested\n\t\t\tuserBundleId\n      ...fragments\n    }\n  }";
export const getUserMembershipsApiCall = async function (_ref3) {
  let {
    userId,
    all,
    customerId
  } = _ref3;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETUSERMEMBERSHIPS_QUERY,
    variables: {
      userId,
      all,
      customerId
    },
    fragments
  });
};
const GETMYMEMBERSHIPS_QUERY = "\n  query getMyMemberships($all: Boolean) {\n    getMyMemberships(all: $all)\n    {\n      id\n\t\t\tuserId\n\t\t\tmembershipId\n\t\t\tsessionsCounter\n\t\t\treservationsCounter\n\t\t\tmembershipType\n\t\t\tmembershipTypeIds\n\t\t\tallInclusive\n\t\t\tisActive\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tdescribedName\n\t\t\tsubscriptionsCounter\n\t\t\tusedSessions\n\t\t\tbookedSessions\n\t\t\tbookedReservations\n\t\t\tusedReservations\n\t\t\ttotalSessionsCounter\n\t\t\ttotalReservationsCounter\n\t\t\tprice\n\t\t\tcustomerId\n\t\t\trules\n\t\t\tisRequested\n\t\t\tuserBundleId\n      ...fragments\n    }\n  }";
export const getMyMembershipsApiCall = async function (_ref4) {
  let {
    all
  } = _ref4;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETMYMEMBERSHIPS_QUERY,
    variables: {
      all
    },
    fragments
  });
};
const GETPROVIDERMEMBERSHIPS_QUERY = "\n  query getProviderMemberships($membershipId: Int) {\n    getProviderMemberships(membershipId: $membershipId)\n    {\n      id\n\t\t\tuserId\n\t\t\tmembershipId\n\t\t\tsessionsCounter\n\t\t\treservationsCounter\n\t\t\tmembershipType\n\t\t\tmembershipTypeIds\n\t\t\tallInclusive\n\t\t\tisActive\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tdescribedName\n\t\t\tsubscriptionsCounter\n\t\t\tusedSessions\n\t\t\tbookedSessions\n\t\t\tbookedReservations\n\t\t\tusedReservations\n\t\t\ttotalSessionsCounter\n\t\t\ttotalReservationsCounter\n\t\t\tprice\n\t\t\tcustomerId\n\t\t\trules\n\t\t\tisRequested\n\t\t\tuserBundleId\n      ...fragments\n    }\n  }";
export const getProviderMembershipsApiCall = async function (_ref5) {
  let {
    membershipId
  } = _ref5;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETPROVIDERMEMBERSHIPS_QUERY,
    variables: {
      membershipId
    },
    fragments
  });
};
const CHECKMEMBERSHIP_QUERY = "\n  query checkMembership($serviceId: Int!, $providerId: Int!, $serviceType: String!) {\n    checkMembership(serviceId: $serviceId, providerId: $providerId, serviceType: $serviceType)\n    {\n      onlinePayments\n\t\t\tserviceHasMembership\n\t\t\tuserHasMembership\n      ...fragments\n    }\n  }";
export const checkMembershipApiCall = async function (_ref6) {
  let {
    serviceId,
    providerId,
    serviceType
  } = _ref6;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHECKMEMBERSHIP_QUERY,
    variables: {
      serviceId,
      providerId,
      serviceType
    },
    fragments
  });
};
const CHECKMEMBERSHIPBYOWNER_QUERY = "\n  query checkMembershipByOwner($userId: Int, $serviceId: Int, $serviceType: String, $customerId: Int) {\n    checkMembershipByOwner(userId: $userId, serviceId: $serviceId, serviceType: $serviceType, customerId: $customerId)\n    {\n      onlinePayments\n\t\t\tserviceHasMembership\n\t\t\tuserHasMembership\n      ...fragments\n    }\n  }";
export const checkMembershipByOwnerApiCall = async function (_ref7) {
  let {
    userId,
    serviceId,
    serviceType,
    customerId
  } = _ref7;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHECKMEMBERSHIPBYOWNER_QUERY,
    variables: {
      userId,
      serviceId,
      serviceType,
      customerId
    },
    fragments
  });
};
const GETAVAILABLEMEMBERSHIPSFORMULTIPLERESERVATIONS_QUERY = "\n  query getAvailableMembershipsForMultipleReservations($serviceId: Int!, $beginDate: DateTime!, $endDate: DateTime, $userId: Int, $customerId: Int) {\n    getAvailableMembershipsForMultipleReservations(serviceId: $serviceId, beginDate: $beginDate, endDate: $endDate, userId: $userId, customerId: $customerId)\n    {\n      onlinePayments\n\t\t\tserviceHasMembership\n\t\t\tuserHasMembership\n      ...fragments\n    }\n  }";
export const getAvailableMembershipsForMultipleReservationsApiCall = async function (_ref8) {
  let {
    serviceId,
    beginDate,
    endDate,
    userId,
    customerId
  } = _ref8;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETAVAILABLEMEMBERSHIPSFORMULTIPLERESERVATIONS_QUERY,
    variables: {
      serviceId,
      beginDate,
      endDate,
      userId,
      customerId
    },
    fragments
  });
};
const CHECKMEMBERSHIPBYOWNERBYORDERID_QUERY = "\n  query checkMembershipByOwnerByOrderId($orderId: Int!, $serviceId: Int!) {\n    checkMembershipByOwnerByOrderId(orderId: $orderId, serviceId: $serviceId)\n    {\n      onlinePayments\n\t\t\tserviceHasMembership\n\t\t\tuserHasMembership\n      ...fragments\n    }\n  }";
export const checkMembershipByOwnerByOrderIdApiCall = async function (_ref9) {
  let {
    orderId,
    serviceId
  } = _ref9;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHECKMEMBERSHIPBYOWNERBYORDERID_QUERY,
    variables: {
      orderId,
      serviceId
    },
    fragments
  });
};
const CHECKMEMBERSHIPBYOWNERFORSERVICE_QUERY = "\n  query checkMembershipByOwnerForService($serviceId: Int!, $date: DateTime!, $userId: Int, $customerId: Int) {\n    checkMembershipByOwnerForService(serviceId: $serviceId, date: $date, userId: $userId, customerId: $customerId)\n  }";
export const checkMembershipByOwnerForServiceApiCall = async _ref0 => {
  let {
    serviceId,
    date,
    userId,
    customerId
  } = _ref0;
  return apiCall({
    query: CHECKMEMBERSHIPBYOWNERFORSERVICE_QUERY,
    variables: {
      serviceId,
      date,
      userId,
      customerId
    }
  });
};
const GETALLBOOKINGSFORMEMBERSHIP_QUERY = "\n  query getAllBookingsForMembership($id: Int!) {\n    getAllBookingsForMembership(id: $id)\n  }";
export const getAllBookingsForMembershipApiCall = async _ref1 => {
  let {
    id
  } = _ref1;
  return apiCall({
    query: GETALLBOOKINGSFORMEMBERSHIP_QUERY,
    variables: {
      id
    }
  });
};
const GETMEMBERSHIPRULES_QUERY = "\n  query getMembershipRules {\n    getMembershipRules\n    {\n      id\n\t\t\tproviderId\n\t\t\tname\n\t\t\ttype\n\t\t\tperiod\n\t\t\tamount\n      ...fragments\n    }\n  }";
export const getMembershipRulesApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETMEMBERSHIPRULES_QUERY,
    variables: {},
    fragments
  });
};
const GETTOTALBUNDLEPRICEFORUSER_QUERY = "\n  query getTotalBundlePriceForUser($userId: Int, $customerId: Int) {\n    getTotalBundlePriceForUser(userId: $userId, customerId: $customerId)\n  }";
export const getTotalBundlePriceForUserApiCall = async _ref10 => {
  let {
    userId,
    customerId
  } = _ref10;
  return apiCall({
    query: GETTOTALBUNDLEPRICEFORUSER_QUERY,
    variables: {
      userId,
      customerId
    }
  });
};
const GETUSERMEMBERSHIPSBYMEMBERSHIPID_QUERY = "\n  query getUserMembershipsByMembershipId($membershipId: Int!) {\n    getUserMembershipsByMembershipId(membershipId: $membershipId)\n  }";
export const getUserMembershipsByMembershipIdApiCall = async _ref11 => {
  let {
    membershipId
  } = _ref11;
  return apiCall({
    query: GETUSERMEMBERSHIPSBYMEMBERSHIPID_QUERY,
    variables: {
      membershipId
    }
  });
};
const GETMEMBERSHIPSWITHRULES_QUERY = "\n  query getMembershipsWithRules {\n    getMembershipsWithRules\n    {\n      id\n\t\t\tsvcGroupId\n\t\t\tproviderId\n\t\t\tname\n\t\t\tdescription\n\t\t\tprice\n\t\t\tsessionsCounter\n\t\t\treservationsCounter\n\t\t\tsubscriptionsCounter\n\t\t\talwaysAvailable\n\t\t\tduration\n\t\t\tdurationType\n\t\t\tdurationMonths\n\t\t\tisRecurringPayment\n\t\t\tisPublished\n\t\t\tstartTime\n\t\t\tendTime\n\t\t\tmembershipType\n\t\t\tallInclusive\n\t\t\tmembershipTypeIds\n\t\t\tuserHasMembership\n\t\t\torderIndex\n\t\t\twalkinEmail\n\t\t\tisPrimary\n\t\t\trules\n      ...fragments\n    }\n  }";
export const getMembershipsWithRulesApiCall = async function () {
  let fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return apiCall({
    query: GETMEMBERSHIPSWITHRULES_QUERY,
    variables: {},
    fragments
  });
};
const ARCHIVEMEMBERSHIP_QUERY = "\n  mutation archiveMembership($id: Int!) {\n    archiveMembership(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const archiveMembershipApiCall = async function (_ref12) {
  let {
    id
  } = _ref12;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ARCHIVEMEMBERSHIP_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const RESTOREMEMBERSHIP_QUERY = "\n  mutation restoreMembership($id: Int!) {\n    restoreMembership(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const restoreMembershipApiCall = async function (_ref13) {
  let {
    id
  } = _ref13;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: RESTOREMEMBERSHIP_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const SAVEMEMBERSHIP_QUERY = "\n  mutation saveMembership($name: String!, $description: String!, $price: Float!, $sessionsCounter: Int!, $reservationsCounter: Int!, $membershipType: String!, $svcGroupId: Int!, $membershipTypeIds: String, $startTime: DateTime, $endTime: DateTime, $isPublished: Boolean, $duration: Int, $durationType: String, $allInclusive: Boolean, $id: Int, $alwaysAvailable: Boolean, $rules: String, $propagatedUserMemberships: [String], $isPrimary: Boolean) {\n    saveMembership(name: $name, description: $description, price: $price, sessionsCounter: $sessionsCounter, reservationsCounter: $reservationsCounter, membershipType: $membershipType, svcGroupId: $svcGroupId, membershipTypeIds: $membershipTypeIds, startTime: $startTime, endTime: $endTime, isPublished: $isPublished, duration: $duration, durationType: $durationType, allInclusive: $allInclusive, id: $id, alwaysAvailable: $alwaysAvailable, rules: $rules, propagatedUserMemberships: $propagatedUserMemberships, isPrimary: $isPrimary)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const saveMembershipApiCall = async function (_ref14) {
  let {
    name,
    description,
    price,
    sessionsCounter,
    reservationsCounter,
    membershipType,
    svcGroupId,
    membershipTypeIds,
    startTime,
    endTime,
    isPublished,
    duration,
    durationType,
    allInclusive,
    id,
    alwaysAvailable,
    rules,
    propagatedUserMemberships,
    isPrimary
  } = _ref14;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: SAVEMEMBERSHIP_QUERY,
    variables: {
      name,
      description,
      price,
      sessionsCounter,
      reservationsCounter,
      membershipType,
      svcGroupId,
      membershipTypeIds,
      startTime,
      endTime,
      isPublished,
      duration,
      durationType,
      allInclusive,
      id,
      alwaysAvailable,
      rules,
      propagatedUserMemberships,
      isPrimary
    },
    fragments
  });
};
const TOGGLEMEMBERSHIPSTATUS_QUERY = "\n  mutation toggleMembershipStatus($id: Int!, $isPublished: Boolean!) {\n    toggleMembershipStatus(id: $id, isPublished: $isPublished)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const toggleMembershipStatusApiCall = async function (_ref15) {
  let {
    id,
    isPublished
  } = _ref15;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: TOGGLEMEMBERSHIPSTATUS_QUERY,
    variables: {
      id,
      isPublished
    },
    fragments
  });
};
const ADDMEMBERSHIPTOUSER_QUERY = "\n  mutation addMembershipToUser($membershipId: Int!, $price: Float!, $membershipType: String!, $allInclusive: Boolean!, $startTime: DateTime, $endTime: DateTime, $membershipTypeIds: String, $sessionsCounter: Int, $reservationsCounter: Int, $userId: Int, $email: String, $customerId: Int, $paid: Float, $isPaid: Boolean, $method: String, $channel: String, $rules: String) {\n    addMembershipToUser(membershipId: $membershipId, price: $price, membershipType: $membershipType, allInclusive: $allInclusive, startTime: $startTime, endTime: $endTime, membershipTypeIds: $membershipTypeIds, sessionsCounter: $sessionsCounter, reservationsCounter: $reservationsCounter, userId: $userId, email: $email, customerId: $customerId, paid: $paid, isPaid: $isPaid, method: $method, channel: $channel, rules: $rules)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const addMembershipToUserApiCall = async function (_ref16) {
  let {
    membershipId,
    price,
    membershipType,
    allInclusive,
    startTime,
    endTime,
    membershipTypeIds,
    sessionsCounter,
    reservationsCounter,
    userId,
    email,
    customerId,
    paid,
    isPaid,
    method,
    channel,
    rules
  } = _ref16;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ADDMEMBERSHIPTOUSER_QUERY,
    variables: {
      membershipId,
      price,
      membershipType,
      allInclusive,
      startTime,
      endTime,
      membershipTypeIds,
      sessionsCounter,
      reservationsCounter,
      userId,
      email,
      customerId,
      paid,
      isPaid,
      method,
      channel,
      rules
    },
    fragments
  });
};
const CHANGEUSERMEMBERSHIPSTATUS_QUERY = "\n  mutation changeUserMembershipStatus($id: Int, $userId: Int, $isActive: Boolean, $customerId: Int) {\n    changeUserMembershipStatus(id: $id, userId: $userId, isActive: $isActive, customerId: $customerId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const changeUserMembershipStatusApiCall = async function (_ref17) {
  let {
    id,
    userId,
    isActive,
    customerId
  } = _ref17;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CHANGEUSERMEMBERSHIPSTATUS_QUERY,
    variables: {
      id,
      userId,
      isActive,
      customerId
    },
    fragments
  });
};
const UPDATEORDERPAIDWITHMEMBERSHIP_QUERY = "\n  mutation updateOrderPaidWithMembership($orderId: Int!, $membershipId: Int!) {\n    updateOrderPaidWithMembership(orderId: $orderId, membershipId: $membershipId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const updateOrderPaidWithMembershipApiCall = async function (_ref18) {
  let {
    orderId,
    membershipId
  } = _ref18;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEORDERPAIDWITHMEMBERSHIP_QUERY,
    variables: {
      orderId,
      membershipId
    },
    fragments
  });
};
const REORDERMEMBERSHIP_QUERY = "\n  mutation reorderMembership($oldPosition: Int!, $newPosition: Int!, $groupId: Int!) {\n    reorderMembership(oldPosition: $oldPosition, newPosition: $newPosition, groupId: $groupId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const reorderMembershipApiCall = async function (_ref19) {
  let {
    oldPosition,
    newPosition,
    groupId
  } = _ref19;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REORDERMEMBERSHIP_QUERY,
    variables: {
      oldPosition,
      newPosition,
      groupId
    },
    fragments
  });
};
const REQUESTMEMBERSHIPCUSTOMER_QUERY = "\n  mutation requestMembershipCustomer($membershipId: Int!, $startTime: DateTime!, $quantity: Int) {\n    requestMembershipCustomer(membershipId: $membershipId, startTime: $startTime, quantity: $quantity)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const requestMembershipCustomerApiCall = async function (_ref20) {
  let {
    membershipId,
    startTime,
    quantity
  } = _ref20;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REQUESTMEMBERSHIPCUSTOMER_QUERY,
    variables: {
      membershipId,
      startTime,
      quantity
    },
    fragments
  });
};
const REQUESTBUNDLECUSTOMER_QUERY = "\n  mutation requestBundleCustomer($bundleId: String!, $startTime: DateTime!) {\n    requestBundleCustomer(bundleId: $bundleId, startTime: $startTime)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const requestBundleCustomerApiCall = async function (_ref21) {
  let {
    bundleId,
    startTime
  } = _ref21;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: REQUESTBUNDLECUSTOMER_QUERY,
    variables: {
      bundleId,
      startTime
    },
    fragments
  });
};
const APPROVEUSERMEMBERSHIP_QUERY = "\n  mutation approveUserMembership($userMembershipId: Int!) {\n    approveUserMembership(userMembershipId: $userMembershipId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const approveUserMembershipApiCall = async function (_ref22) {
  let {
    userMembershipId
  } = _ref22;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: APPROVEUSERMEMBERSHIP_QUERY,
    variables: {
      userMembershipId
    },
    fragments
  });
};
const CREATEMEMBERSHIPRULE_QUERY = "\n  mutation createMembershipRule($request: MembershipRuleInput!) {\n    createMembershipRule(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const createMembershipRuleApiCall = async function (_ref23) {
  let {
    request
  } = _ref23;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: CREATEMEMBERSHIPRULE_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const ARCHIVEMEMBERSHIPRULE_QUERY = "\n  mutation archiveMembershipRule($id: Int!) {\n    archiveMembershipRule(id: $id)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const archiveMembershipRuleApiCall = async function (_ref24) {
  let {
    id
  } = _ref24;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ARCHIVEMEMBERSHIPRULE_QUERY,
    variables: {
      id
    },
    fragments
  });
};
const UPDATEMEMBERSHIPRULE_QUERY = "\n  mutation updateMembershipRule($request: MembershipRuleInput!) {\n    updateMembershipRule(request: $request)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const updateMembershipRuleApiCall = async function (_ref25) {
  let {
    request
  } = _ref25;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEMEMBERSHIPRULE_QUERY,
    variables: {
      request
    },
    fragments
  });
};
const UPDATEUSERMEMBERSHIPRULES_QUERY = "\n  mutation updateUserMembershipRules($id: Int!, $startTime: DateTime!, $endTime: DateTime!, $rules: String!) {\n    updateUserMembershipRules(id: $id, startTime: $startTime, endTime: $endTime, rules: $rules)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const updateUserMembershipRulesApiCall = async function (_ref26) {
  let {
    id,
    startTime,
    endTime,
    rules
  } = _ref26;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: UPDATEUSERMEMBERSHIPRULES_QUERY,
    variables: {
      id,
      startTime,
      endTime,
      rules
    },
    fragments
  });
};